import { useEffect, useState } from "react";

interface IGracePeriodCountdown {
  deadline: Date;
}

const formatRemaining = (ms: number): string => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

const GracePeriodCountdown = ({ deadline }: IGracePeriodCountdown) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const remainingMs = deadline.getTime() - now.getTime();

  return <p dir="ltr">{formatRemaining(remainingMs)}</p>;
};

export default GracePeriodCountdown;
